import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../../api";
import { Spinner } from "../../components/Logo";
import { PageHeader } from "../../components/ui";
import { Save, Settings } from "lucide-react";

const labels = {
  platform_name: "Platform name",
  quiz_default_pass_threshold: "Default quiz pass threshold (%)",
  ctf_default_hint_cost: "Default CTF hint cost (XP)",
  xp_per_level: "XP required per level",
  daily_goal_xp: "Daily goal (XP)",
};

export default function AdminConfig() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/config").then((r) => {
      const obj = {};
      r.data.config.forEach((c) => { obj[c.key] = c.value; });
      setCfg(obj);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try { await api.post("/admin/config", cfg); toast.success("Configuration saved"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  if (!cfg) return <Spinner />;

  return (
    <div data-testid="admin-config">
      <PageHeader overline="Platform" title="Configuration" desc="Tune platform-wide defaults. All changes are audit logged." />
      <div className="card p-6 max-w-2xl space-y-4">
        {Object.keys(cfg).map((k) => (
          <div key={k}>
            <label className="label">{labels[k] || k}</label>
            <input className="input" value={cfg[k]} onChange={(e) => setCfg({ ...cfg, [k]: e.target.value })} data-testid={`config-${k}`} />
          </div>
        ))}
        <button className="btn-primary" onClick={save} disabled={busy} data-testid="save-config-btn"><Save size={16} /> Save configuration</button>
      </div>
    </div>
  );
}
